// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messageMenu {
  display: flex;
  /* flex-direction: column; */
  /* padding: 0 2em; */
  align-items: flex-end;
  /* justify-content: space-between; */
  width: 100%;
  /* max-width: 20rem; */
  /* flex: 1 1 25%; */
  gap: 1rem;
  /* height: 100%; */
  margin: 2rem 0;
}

.messageMenu__nav {
  display: flex;
  /* height: 100%; */
  flex-direction: column;
  /* align-items: center; */
  width: 100%;
}

.messageMenu__menuTitle {
  color: var(--clr-gray600);
  font-size: 1.15rem;
  font-weight: 600;
  text-transform: uppercase;
}

.messageMenu__menuItems {
  display: flex;
  width: 100%;
  margin-top: 0.75rem;
  border-radius: 1em;
  overflow: hidden;
  /* gap: 0.5rem; */
  box-shadow: 0px 0.75rem 1rem rgba(0, 0, 0, 0.04);
  background: var(--clr-gray200);
}

.messageMenu__menuItem {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  /* justify-content: space-between; */
  font-weight: 600;
  padding: 1em 1.5em;
  border-radius: 1em;
  font-size: 0.9rem;
  color: var(--clr-gray600);
  cursor: pointer;
  /* margin-top: 0.75rem; */
  transition: 0.25s;
}

.messageMenu__menuItem > div span {
  display: none;
  margin-left: 1rem;
}

.messageMenu__menuItem > div {
  display: flex;
  align-items: center;
}

.messageMenu__menuItem svg {
  /* width: 1.25rem; */
  width: 1.5rem;
  fill: transparent;
}

.messageMenu__menuItem svg rect,
.messageMenu__menuItem svg path {
  stroke: var(--clr-gray600);
}

/* .messageMenu__menuItem:hover, */
.messageMenu__menuItem.active {
  background: var(--clr-primary);
  color: var(--clr-light);
}

.messageMenu__unread {
  display: grid;
  place-items: center;
  border-radius: 50%;
  width: 1.25rem;
  /* width: 1.5rem; */
  height: 1.25rem;
  /* height: 1.5rem; */
  font-size: 0.8rem;
  margin-left: 0.5rem;
  font-weight: bold;
  background: #ecd9d9;
  color: var(--clr-primary);
}

/* .messageMenu__menuItem:hover svg rect, */
/* .messageMenu__menuItem:hover svg path, */
.messageMenu__menuItem.active svg rect,
.messageMenu__menuItem.active svg path {
  stroke: var(--clr-light);
}

.messageMenu__setting {
  display: none;
  align-items: center;
  color: var(--clr-primary);
  font-weight: 600;
  font-size: 1rem;
  padding: 1em 1.5em;
  border-radius: 1em;
  cursor: pointer;
}

.messageMenu__setting svg {
  margin-right: 1rem;
  width: 1.75rem;
}

@media (min-width: 992px) {
  .messageMenu__menuItem {
    justify-content: space-between;
  }
  .messageMenu__menuItem > div span {
    display: block;
  }
}

@media (min-width: 1200px) {
  .messageMenu__setting {
    display: flex;
  }
}

@media (min-width: 1920px) {
  .messageMenu {
    position: absolute;
    flex-direction: column;
    align-items: flex-start;
    max-width: 17rem;
    right: calc(100% + 2rem);
    height: 47.5rem;
    margin-bottom: 0;
    margin-top: 0.75rem;
    justify-content: space-between;
  }

  .messageMenu__menuItems {
    flex-direction: column;
    background: transparent;
    box-shadow: none;
  }

  .messageMenu__menuItem {
    margin-top: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MessageComponents/MessageMenu/MessageMenu.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;EACrB,oCAAoC;EACpC,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gDAAgD;EAChD,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,iBAAiB;AACnB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA,kCAAkC;AAClC;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C,2CAA2C;AAC3C;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".messageMenu {\n  display: flex;\n  /* flex-direction: column; */\n  /* padding: 0 2em; */\n  align-items: flex-end;\n  /* justify-content: space-between; */\n  width: 100%;\n  /* max-width: 20rem; */\n  /* flex: 1 1 25%; */\n  gap: 1rem;\n  /* height: 100%; */\n  margin: 2rem 0;\n}\n\n.messageMenu__nav {\n  display: flex;\n  /* height: 100%; */\n  flex-direction: column;\n  /* align-items: center; */\n  width: 100%;\n}\n\n.messageMenu__menuTitle {\n  color: var(--clr-gray600);\n  font-size: 1.15rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.messageMenu__menuItems {\n  display: flex;\n  width: 100%;\n  margin-top: 0.75rem;\n  border-radius: 1em;\n  overflow: hidden;\n  /* gap: 0.5rem; */\n  box-shadow: 0px 0.75rem 1rem rgba(0, 0, 0, 0.04);\n  background: var(--clr-gray200);\n}\n\n.messageMenu__menuItem {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  /* justify-content: space-between; */\n  font-weight: 600;\n  padding: 1em 1.5em;\n  border-radius: 1em;\n  font-size: 0.9rem;\n  color: var(--clr-gray600);\n  cursor: pointer;\n  /* margin-top: 0.75rem; */\n  transition: 0.25s;\n}\n\n.messageMenu__menuItem > div span {\n  display: none;\n  margin-left: 1rem;\n}\n\n.messageMenu__menuItem > div {\n  display: flex;\n  align-items: center;\n}\n\n.messageMenu__menuItem svg {\n  /* width: 1.25rem; */\n  width: 1.5rem;\n  fill: transparent;\n}\n\n.messageMenu__menuItem svg rect,\n.messageMenu__menuItem svg path {\n  stroke: var(--clr-gray600);\n}\n\n/* .messageMenu__menuItem:hover, */\n.messageMenu__menuItem.active {\n  background: var(--clr-primary);\n  color: var(--clr-light);\n}\n\n.messageMenu__unread {\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  width: 1.25rem;\n  /* width: 1.5rem; */\n  height: 1.25rem;\n  /* height: 1.5rem; */\n  font-size: 0.8rem;\n  margin-left: 0.5rem;\n  font-weight: bold;\n  background: #ecd9d9;\n  color: var(--clr-primary);\n}\n\n/* .messageMenu__menuItem:hover svg rect, */\n/* .messageMenu__menuItem:hover svg path, */\n.messageMenu__menuItem.active svg rect,\n.messageMenu__menuItem.active svg path {\n  stroke: var(--clr-light);\n}\n\n.messageMenu__setting {\n  display: none;\n  align-items: center;\n  color: var(--clr-primary);\n  font-weight: 600;\n  font-size: 1rem;\n  padding: 1em 1.5em;\n  border-radius: 1em;\n  cursor: pointer;\n}\n\n.messageMenu__setting svg {\n  margin-right: 1rem;\n  width: 1.75rem;\n}\n\n@media (min-width: 992px) {\n  .messageMenu__menuItem {\n    justify-content: space-between;\n  }\n  .messageMenu__menuItem > div span {\n    display: block;\n  }\n}\n\n@media (min-width: 1200px) {\n  .messageMenu__setting {\n    display: flex;\n  }\n}\n\n@media (min-width: 1920px) {\n  .messageMenu {\n    position: absolute;\n    flex-direction: column;\n    align-items: flex-start;\n    max-width: 17rem;\n    right: calc(100% + 2rem);\n    height: 47.5rem;\n    margin-bottom: 0;\n    margin-top: 0.75rem;\n    justify-content: space-between;\n  }\n\n  .messageMenu__menuItems {\n    flex-direction: column;\n    background: transparent;\n    box-shadow: none;\n  }\n\n  .messageMenu__menuItem {\n    margin-top: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
